import React from 'react'
import Courses from '../components/courses/Courses';
import Navbar from "../components/Navbar/Navbar";




const CoursesListPage = () => {
    return ( 
        <>
       <Navbar/>
       <Courses/>
        </>
     );
}
 
export default CoursesListPage;